//联系人维护
<template>
  <div id="contacts">
    <!-- 搜索框 -->
    <div class="search_aera">
      <el-input
        placeholder="请输入搜索内容"
        size="mini"
        v-model="dest"
        @keyup.enter="getContactsListAction({ options })"
      >
        <el-button
          slot="append"
          size="mini"
          type="primary"
          icon="el-icon-search"
          :disabled="dest.trim() == ''"
          @click="getContactsListAction({ options })"
          title="搜索"
        ></el-button>
      </el-input>
      <span class="item" v-if="getEscSearchIcon" @click="escSearch()">退出搜索</span>
    </div>
    <el-table :data="contactsList" border style="width: 100%" @sort-change="emitSort">
      <el-table-column prop="order__order_number" label="订单编号" align="center" sortable="custom"></el-table-column>
      <el-table-column prop="update_time" align="center" sortable="custom" label="订单时间"></el-table-column>
      <el-table-column prop="user__contact" align="center" sortable="custom" label="联系人"></el-table-column>
      <el-table-column prop="user__phone" align="center" sortable="custom" label="联系人电话"></el-table-column>
      <el-table-column prop="user__email" align="center" sortable="custom" label="联系人邮箱"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="contactDetails(scope)">变更</el-button>
          <el-button type="primary" size="mini" @click="openDialog(scope)">共享</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="currentPage"
      :page-size="pageSize"
      :total="allList"
      :background="true"
      layout="total, prev, pager, next, jumper"
      prev-text="上一页"
      next-text="下一页"
      @current-change="currentPageChange"
    ></el-pagination>
    <el-dialog title="请选择要共享的联系人" :visible.sync="shareVisible">
      <el-transfer
        :data="shareContactsList"
        v-model="SelectedUserId"
        @change="chooseContact"
        :button-texts="['删除', '添加']"
        :titles="['可选列表', '已选列表']"
      ></el-transfer>
      <el-row>
        <el-col :offset="11">
          <el-button @click="shareOrder">提交</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { post } from "@/util/http";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "account",
  beforeCreate() {
    let self = this;
    let token = sessionStorage.getItem("authToken");
    if (!token) {
      this.$router.push({
        name: "pcibLogin"
      });
    }
  },
  created() {
    this.getContactsListAction({ options: this.options });
  },
  data() {
    return {
      pageSize: 10, // 每页显示条数
      currentPage: 1, // 当前页面
      parmas: {}, // 排序信息
      dest: "",
      allList: 0, // 联系人数量
      SelectedUserId: [], // 当前选中的联系人
      SelectedOrderId: "", // 当前选中的订单编号
      selectedContactID: "", // 中间表ID
      contactAddLists: [], // 待添加分享列表
      contactDelLists: [], // 待删除分享列表
      shareVisible: false // 共享弹窗状态
    };
  },
  computed: {
    options() {
      let sort = this.parmas.order
        ? this.parmas.order === "ascending"
          ? this.parmas.prop
          : "-" + this.parmas.prop
        : "";
      return {
        limit: 10,
        offset: (this.currentPage - 1) * 10,
        sort: sort,
        dest: this.dest
      };
    },
    // 联系人列表，从getContactsList中格式化
    contactsList() {
      let arr = [];
      let isEmptyObj = obj => {
        for (let key in obj) {
          return false;
        }
        return true;
      };
      this.getContactsList.forEach(item => {
        let obj = {};
        obj.id = item.id;
        obj.update_time = item.update_time;
        if (item.order && !isEmptyObj(item.order)) {
          Object.keys(item.order).forEach(val => {
            obj["order__" + val] = item.order[val];
          });
        }
        if (item.user && !isEmptyObj(item.user)) {
          Object.keys(item.user).forEach(val => {
            obj["user__" + val] = item.user[val];
          });
        }
        arr.push(obj);
      });
      return arr;
    },
    // getSharedContactsList列表格式化为transfer所需要的格式
    shareContactsList() {
      let arr = [];
      this.getShareableContactsList.forEach(item => {
        let obj = {};
        obj.key = item.username;
        obj.id = item.id;
        obj.label = item.contact;
        obj.disabled = false;
        arr.push(obj);
      });
      return arr;
    },
    // 从getSharedContactsList中提取username列表
    SharedContactsList() {
      let arr = [];
      this.getSharedContactsList.forEach(item => {
        arr.push(item.username);
      });
      return arr;
    },
    ...mapGetters("config", {
      getContactsList: "getContactsList",
      getShareableContactsList: "getShareableContactsList",
      getSharedContactsList: "getSharedContactsList",
      getEscSearchIcon: "getEscSearchIcon"
    })
  },
  methods: {
    currentPageChange(index) {
      this.currentPage = index;
      this.getContactsListAction({ options: this.options });
    },
    emitSort(args) {
      this.parmas = args;
      this.getContactsListAction({ options: this.options });
    },
    contactDetails(scope) {
      this.$router.push({
        name: "contactDetails",
        query: {
          contact_id: scope.row.id
        }
      });
    },
    // 打开弹窗时获取可分享列表和已分享列表并给transfer赋初始值
    openDialog(scope) {
      this.selectedContactID = scope.row.id;
      this.SelectedOrderId = scope.row.order__id;
      this.getShareableContactsListAction({
        order_id: this.SelectedOrderId
      }).then(
        res => {
          this.getSharedContactsListAction({
            order_id: this.SelectedOrderId
          }).then(
            resolve => {
              this.SelectedUserId = this.SharedContactsList;
              this.shareVisible = true;
            },
            err => {
              this.$notify({
                type: "error",
                message: "已分享联系人获取失败",
                duration: 4000
              });
            }
          );
        },
        err => {
          this.$notify({
            type: "error",
            message: "分享联系人获取失败",
            duration: 4000
          });
        }
      );
    },
    // 点击提交
    shareOrder() {
      // 将getSharedContactsList中username列表替换为id列表
      let formatLists = arr => {
        let list = [];
        arr.forEach(item => {
          this.shareContactsList.forEach(val => {
            if (item === val.key) {
              list.push(val.id);
            }
          });
        });
        return list;
      };
      if (this.contactAddLists.length > 0) {
        formatLists(this.contactAddLists).forEach(item => {
          post("ecla/share_contact/", {
            order_id: this.SelectedOrderId,
            user_id: item
          }).then(
            res => {
              this.$notify({
                type: "success",
                message: "联系人分享成功",
                duration: 4000
              });
            },
            err => {
              this.$notify({
                type: "error",
                message: "联系人分享失败",
                duration: 4000
              });
            }
          );
        });
        return true;
      }
      if (this.contactDelLists.length > 0) {
        let ids = [];
        this.contactDelLists.forEach(item => {
          this.getSharedContactsList.forEach(val => {
            if (item === val.username) {
              ids.push(val.id);
            }
          });
        });
        this.axios
          .delete("ecla/del_share/", {
            data: {
              ids: ids
            },
            headers: {
              "Content-Type": "application/json", //设置跨域头部
              Authorization: "JWT " + sessionStorage.getItem("authToken")
            }
          })
          .then(
            res => {
              this.$notify({
                type: "success",
                message: "联系人删除成功",
                duration: 4000
              });
            },
            err => {
              this.$notify({
                type: "error",
                message: "联系人删除失败",
                duration: 4000
              });
            }
          );
        return true;
      }
      this.$notify({
        type: "info",
        message: "数据未做任何改动",
        duration: 4000
      });
    },
    // transfer添加/删除 操作时判断并更改 待添加/待删除 分享的列表
    chooseContact(results, action, keys) {
      keys.forEach(item => {
        if (action === "right") {
          let index = this.contactDelLists.indexOf(item);
          if (index !== "-1") {
            this.contactDelLists.splice(index, 1);
          }
          if (!this.SharedContactsList.indexOf(item) > -1) {
            this.contactAddLists.push(item);
          }
        }
        if (action === "left") {
          let index = this.contactAddLists.indexOf(item);
          if (index !== "-1") {
            this.contactAddLists.splice(index, 1);
          }

          if (this.SharedContactsList.ndexOf(item) > -1) {
            this.contactDelLists.push(item);
          }
        }
      });
    },
    // 关闭弹窗
    closeTransfer() {
      this.shareVisible = false;
    },
    escSearch() {
      this.dest = "";
      this.getContactsListAction({ options: this.options });
    },
    ...mapActions("config", {
      getContactsListAction: "getContactsListAction",
      getShareableContactsListAction: "getShareableContactsListAction",
      getSharedContactsListAction: "getSharedContactsListAction"
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/mirrors/auths/Contacts.vue